import { render, staticRenderFns } from "./OrganisationsWidget.vue?vue&type=template&id=ffe8cad0&scoped=true"
import script from "./OrganisationsWidget.vue?vue&type=script&lang=js"
export * from "./OrganisationsWidget.vue?vue&type=script&lang=js"
import style0 from "./OrganisationsWidget.vue?vue&type=style&index=0&id=ffe8cad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8cad0",
  null
  
)

export default component.exports